import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ModalService } from '../../../../../../../components/modal-list/modal-list.service';
import { CommonModule } from '@angular/common';
import { SharedSelectionTableComponent } from '../shared-selection-table/shared-selection-table.component';
import { Subscription, combineLatest } from 'rxjs';
import { I18nModule, TranslationService } from '@spartacus/core';
import { AccountSelectionService } from '../account-selection/account-selection.service';
import { SoldToModalComponent } from '../sold-to-modal/sold-to-modal.component';
import { SpinnerModule } from '@spartacus/storefront';
import { LocalStorageService } from '../../../../../../../core/services/localStorage.service';

interface Address {
  uid: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  additionalInfo?: string;
	defaultWarehouseCode?: string;
}

@Component({
  selector: 'app-modal-1',
  standalone: true,
  imports: [CommonModule, SharedSelectionTableComponent, I18nModule, SpinnerModule],
  templateUrl: './ship-to-modal.component.html',
  styleUrl: './ship-to-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipToModalComponent implements OnInit, OnDestroy {
  address$ = this.accountSelectionService.getUserAddresByLocalStorageSelectedAccount();
  jsonItemName = 'selectedAddress';
  selectedItem: any = undefined;
  @Input() data?: any = {};
  columns: { key: keyof Address; label: string; keyString: string }[] = [
    { key: 'street', label: '', keyString: 'street' },
    { key: 'city', label: '', keyString: 'city' },
    { key: 'state', label: '', keyString: 'state' },
    { key: 'postalCode', label: '', keyString: 'postalCode' },
    { key: 'country', label: '', keyString: 'country' },
    { key: 'additionalInfo', label: '', keyString: 'additionalInfo' },
		{ key: 'defaultWarehouseCode', label: '', keyString: 'defaultWarehouseCode' },
  ];
  orgUnit$ = this.accountSelectionService.getCurrent();

  subscription = new Subscription();

  constructor(
    private modalService: ModalService,
    private translationService: TranslationService,
    private accountSelectionService: AccountSelectionService,
    private localStorageSerivce: LocalStorageService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.translateMessages();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  translateMessages() {
    const translations = this.columns.map(column =>
      this.translationService.translate(`accountSelection.columns.${column.keyString}`),
    );
    this.subscription.add(
      combineLatest(translations).subscribe(messages => {
        messages.forEach((message, i) => {
          this.columns[i].label = message;
        });
      }),
    );
  }

  skipModal() {
    this.accountSelectionService.skipSelectionModal(this.data?.isLogin);
  }

  backModal() {
    this.modalService.close();
    this.accountSelectionService.openSelectionModal(SoldToModalComponent, 'sold-to-modal', this.data.isLogin);
  }

  closeModal() {
    this.handleSelectedItem();
    this.modalService.close();
  }

  handleSelectedItem() {
    this.accountSelectionService.setAddress(this.selectedItem);
    if (!this.data.isLogin) {
      this.accountSelectionService.setRemovedCartMessage();
    }
  }

  setItem(item: any) {
    this.selectedItem = item;
    this.cd.markForCheck();
  }
}
